import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  public isLoading = new BehaviorSubject(false);

  // Contador para saber cuantas peticiones estan en proceso
  countProgress = 0;

  constructor() {}

  showLoader(addCount = true): void {
    if (addCount) this.countProgress++;
    this.isLoading.next(true);
  }

  hideLoader(): void {
    this.countProgress--;
    if (this.countProgress <= 0) {
      this.countProgress = 0;
      this.isLoading.next(false);
    }
  }
}
